import React from "react";
import { Table } from "antd";
import get from "lodash/get";
import round from "lodash/round";
import { checkNullable} from "../../../utilities/helpers";


const PnlTableSummary = ({ summary, templateType }) => {
  return (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0} colSpan={2}>
        <p className="font-semibold text-center">Total</p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1}>
        <p className="text-center">
          {round(get(summary, "shift_meta.available_hours"),2) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={2}>
        <p className="text-center">
          {round(get(summary, "shift_meta.running_hours"),2) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3}>
        <p className="text-center">
          {round(get(summary, "shift_meta.efficiency"), 2) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={4}>
        <p className="text-center">
          {" "}
          {
            Number(round(get(summary, "shift_meta.product_efficiency"),2))
          }
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={5}>
        <p className="text-center">
          {checkNullable(round(get(summary, "shift_meta.production_amount"),2)) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={6}>
        <p className="text-center">
          {checkNullable(round(get(summary, "shift_meta.per_hour_cost"),2)) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={7}>
        <p className="text-center">
          {checkNullable(round(get(summary, "shift_meta.sale_profit"),2)) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={8}>
        <p className="text-center">
          {checkNullable(round(get(summary, "shift_meta.salary_amount"),2)) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={9}>
        <p className="text-center">
          {checkNullable(round(get(summary, "shift_meta.salary_percent"),2)) || 0}
        </p>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={10}>
        <p className="text-center">
          {checkNullable(round(get(summary, "shift_meta.job_profit"),2)) || 0}
        </p>
      </Table.Summary.Cell>
    </Table.Summary.Row>
  );

};

export default PnlTableSummary;
